/**
 * 尽量在全局减少页面被缩放：移动端以 viewport 为主；本模块补充桌面端 Ctrl/⌘+滚轮与部分快捷键。
 * 受浏览器策略与无障碍设置影响，无法保证所有环境下完全禁缩放。
 */
export function initDisablePageZoom() {
  const blockWheelZoom = (e: WheelEvent) => {
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault();
    }
  };
  document.addEventListener("wheel", blockWheelZoom, { passive: false, capture: true });

  const blockKeyZoom = (e: KeyboardEvent) => {
    if (!e.ctrlKey && !e.metaKey) return;
    // + / = / - / 0 及数字小键盘
    if (
      e.key === "+" ||
      e.key === "-" ||
      e.key === "=" ||
      e.key === "0" ||
      e.key === "Add" ||
      e.key === "Subtract"
    ) {
      e.preventDefault();
    }
  };
  document.addEventListener("keydown", blockKeyZoom, true);
}
